export default "__VITE_ASSET__Cr$XGck___"